// Guarded Service Worker registration. Runs only in production browsers
// outside iframes and outside Lovable preview hosts to avoid cache pollution.
export function registerPwa() {
  if (typeof window === "undefined" || !("serviceWorker" in navigator)) return;

  const isInIframe = (() => {
    try { return window.self !== window.top; } catch { return true; }
  })();
  const host = window.location.hostname;
  const isPreviewHost =
    host.includes("id-preview--") ||
    host.includes("lovableproject.com") ||
    host === "localhost" ||
    host === "127.0.0.1";

  if (isInIframe || isPreviewHost) {
    // Clean any previously registered SW so the preview never serves stale assets.
    navigator.serviceWorker.getRegistrations().then((regs) => {
      regs.forEach((r) => r.unregister().catch(() => {}));
    }).catch(() => {});
    return;
  }

  // Lazy import keeps workbox out of the preview bundle path.
  import("virtual:pwa-register").then(({ registerSW }) => {
    const updateSW = registerSW({
      immediate: true,
      onNeedRefresh() {
        // Auto-update on next navigation; keep silent to avoid UI noise.
        updateSW(true).catch(() => {});
      },
      onRegisteredSW(_swUrl: string, registration: ServiceWorkerRegistration | undefined) {
        // Periodic Background Sync (best-effort, Chrome Android only).
        const ps = (registration as unknown as { periodicSync?: { register: (tag: string, opts: { minInterval: number }) => Promise<void> } } | undefined)?.periodicSync;
        if (ps && "permissions" in navigator) {
          navigator.permissions
            .query({ name: "periodic-background-sync" as PermissionName })
            .then((status) => {
              if (status.state === "granted") {
                ps.register("refresh-dashboard", { minInterval: 24 * 60 * 60 * 1000 }).catch(() => {});
              }
            })
            .catch(() => {});
        }
      },
    });
  }).catch(() => {});
}
